import type { IconProps } from "./thumba-coin";

export const SpeakerIcon = (props: IconProps) => (
  <svg width={30} height={30} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_11387_63708)">
      <path
        d="M11.875 12.5V17.5L26.25 23.75V3.75L11.875 10H3.75V17.5H8.125"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.125 17.5V26.25H13.125V20.625" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_11387_63708">
        <rect width={30} height={30} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
